import React from 'react'
import { Box, Typography } from "@mui/material"
import Renderer from '../../../../components/renderer';
import { getAnswerFromSelected, getMarks } from '../../../../utils'
import CorrectAnswer from '../../../../components/results/CorrectAnswer'
import Answer from '../../../../components/results/Answer'
import MatchTheFollowing from '../../../../components/quiz/MatchTheFollowing';
import { evaluateMTF } from '../../../../utils';

const PreviewQuestion = ({ question }) => {

    const selectedAnswer = []

    return (
        <Box>
            <Typography
                align="left"
                variant="h1"
                color="primary.blue"
                sx={{
                    margin: '0',
                    fontWeight: '700',
                    lineHeight: '1.5',
                    fontSize: '2rem',
                }}>{'Preview'}</Typography>
            <span style={styles.score} className={'scores ' + (question?.marks ? 'color-success' : 'color-wrong')}>{`Score ${question?.answerDetails?.options?.marks}`}</span>
            <div style={styles.questionContainer}>
                <div style={{ width: '100%' }}>
                    <div style={styles.questionInnerContainer}>
                        {/* <span style={styles.question}>{questionDetails.text}</span> */}
                        <Renderer content={question?.questionDetails.text} mediaStyle={{ height: '150px', width: '150px' }} style={{ width: 'auto', alignItems: 'start' }}
                            contentUrl={question?.questionDetails.contentURL}
                            contentType={question?.questionDetails.style}
                            overrideHTML={question?.questionDetails.overrideHTML}
                            contentDisplayType={question?.type}
                            helpText={question?.answerDetails?.options?.helpText}
                            disabled={true}
                            enableTextToAudio={true}
                            templateType={question?.questionDetails.displayTemplate} />
                    </div>
                    <div>
                        <div className='grid-container'>
                            {question?.answerDetails?.options?.values && !(question?.answerDetails?.options?.MTFLHS?.length > 0) && question?.answerDetails?.options?.values.length ? question?.answerDetails?.options?.values.map((ans, index) => {
                                // let { correct, wrong } = evaluate(question?.type, selectedAnswer, ans, question?.answerDetails?.options?.answerLabels);
                                return (
                                    <Answer className='grid-item' key={ans.label} label={ans.label} data={ans} content={ans?.value?.text} />
                                )
                            }) : (
                                <React.Fragment>
                                    {(() => {
                                        if (question?.type == 'MTF') {
                                            let left = question?.answerDetails.options?.MTFLHS;
                                            let right = question?.answerDetails.options?.MTFRHS;
                                            let evaluated = evaluateMTF(left, right, selectedAnswer, getMarks(question?.answerDetails));

                                            return (
                                                <MatchTheFollowing
                                                    disabled={true}
                                                    mode={'result'}
                                                    selectedAnswer={evaluated.ans}
                                                    left={evaluated.left}
                                                    right={evaluated.right}
                                                    helpText={question?.answerDetails?.options?.helpText}
                                                    preview={true}
                                                    evaluated={true}
                                                    enableTextToAudio={true}
                                                />
                                            );
                                        } else {
                                            let ans = getAnswerFromSelected(selectedAnswer);
                                            // let { correct, wrong } = evaluate(type, ans, null, answerLabels);

                                            return (
                                                <Answer
                                                    className='grid-item'
                                                    data={ans}
                                                    content={(Array.isArray(ans) ? ans : []).join('')}
                                                // wrong={wrong}
                                                // correct={correct}
                                                />
                                            );
                                        }
                                    })()}
                                </React.Fragment>
                            )}
                        </div>
                        {/* only show if the answer is wrong and not MTF */}
                        {question?.type != 'MTF' && (
                            <CorrectAnswer answerLabels={question?.answerDetails?.options?.answerLabels} type={question?.type} choices={question?.answerDetails?.options?.values} />
                        )}
                    </div>
                </div>

            </div>

        </Box>
    )
}


const styles = {
    container: {
        border: 'none'
    },
    innerContainer: {
        background: 'var(--color-white)',
        borderRadius: '4px',
        margin: '0 auto',
        padding: '0 0 40px',
    },
    questionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px',
    },
    questionInnerContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    questionNumber: {
        fontSize: 'clamp(16px, 5vw, 24px)',
        fontWeight: 500,
        margin: 0,
        marginRight: '18px',
        color: 'var(--color-black)',
    },
    question: {
        fontSize: 'clamp(16px, 5vw, 24px)',
        fontWeight: 500,
        lineHeight: 1.3,
        color: 'var(--color-black)',
        marginBottom: '20px',
    },
    renderer: {
        width: '90%',
        marginBottom: '40px',
        paddingLeft: '40px'
    },
    score: {
        fontWeight: 500,
        fontSize: '16px',
        marginTop: '4px',
    },
    retryContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '40px'
    },
    closeModal: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    }
}


export default PreviewQuestion;
